module.exports = __webpack_public_path__ + "img/technicalSupervision_uncheck.5ff768ed.png";